import { buttonClass } from '../kit/button-class';

/** A legacy `btn-primary` (for links styled as buttons). */
export const primaryButton = buttonClass({ variant: 'primary' });

/** A legacy `btn-secondary`. */
export const secondaryButton = buttonClass({ variant: 'secondary' });
